import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static identifier = "promotion"
    static targets = ["progressContainer", "progressBar", "progressText", "actionButtons", "acceptForm"]
    static values = { tier: Number, name: String }

    connect() {
    }

    accept(event) {
        event.preventDefault()
        
        // Hide action buttons and show progress
        this.actionButtonsTarget.style.display = "none"
        this.progressContainerTarget.style.display = "block"
        
        // Start the 10-second progress animation
        this.startProgressAnimation()
    }

    startProgressAnimation() {
        const duration = 5000 // 5 seconds
        const startTime = Date.now()
        const barWidth = 25
        
        const updateProgress = () => {
            const elapsed = Date.now() - startTime
            const progress = Math.min((elapsed / duration) * 100, 100)
            
            // Calculate ASCII progress bar
            const filled = Math.round((progress / 100) * barWidth)
            const empty = barWidth - filled
            const ascii = `[ ${"⠿".repeat(filled)}${"⠐".repeat(empty)} ]`
            
            // Update progress bar
            const progressBarElement = this.progressBarTarget.querySelector(".ascii-progress-bar")
            if (progressBarElement) {
                progressBarElement.textContent = ascii
                progressBarElement.title = `Upload Progress: ${progress.toFixed(1)}%`
            }
            
            // Update progress text
            if (this.hasProgressTextTarget) {
                this.progressTextTarget.textContent = `Uploading credentials to ${this.getDepartmentName()}... ${progress.toFixed(1)}%`
            }
            
            // Continue animation or submit form
            if (progress < 100) {
                requestAnimationFrame(updateProgress)
            } else {
                // Animation complete, submit the form
                setTimeout(() => {
                    this.acceptFormTarget.submit()
                }, 500) // Small delay to show 100% completion
            }
        }
        
        updateProgress()
    }
    
    getDepartmentName() {
        return this.nameValue
    }
}
